import { sort } from 'timsort'
import { DataEvent } from './charts/types'
import { StateTimelineEvent, StateTimelineItems, StateTimelineMessage, StateTimelineState } from './types'

type RigState = State & {
    items: any[]
}

function getInitialState(): StateTimelineState {
    return {
        start: { info: { span: { normalized: '' } } },
        items: [],
        span: { begin: 0, end: 0 }
    }
}

export const newStatetimelineReducer: WidgetReducerType<StateTimelineState, StateTimelineMessage> = (
    state = getInitialState(),
    message
) => {
    console.log('state', state)

    if (!message) {
        return state
    }
    if ((message.baseline && message.type !== 'event') || message.layer > 0) {
        return state
    }
    
    switch (message?.type) {
        case 'start':
            return onStartQuery(state, message)

        case 'event':
            return onEventQuery(state, message)

        // case 'endHistory':
        //     return getEndState(state)

        case 'span':
            return onSpanQuery(state, message)

        default:
            return state
    }
}

function onStartQuery(state: StateTimelineState, message: StartFlowMessage<StateTimelineEvent>): StateTimelineState {
    return {
        ...state,
        start: message.events,
        items: []
    }
}

function onSpanQuery(state: StateTimelineState, message: SpanFlowMessage): StateTimelineState {
    const newSpan = message.events

    // TODO: remove items (+1) events.
    return { ...state, span: newSpan }
}

function onEventQuery(state: StateTimelineState, message: EventFlowMessage<StateTimelineItems>): StateTimelineState {
    if (message.events.length === 0) {
        return state
    }

    const newItems = [...state.items, ...message.events]

    sort(newItems, (a: DataEvent, b: DataEvent) => a.timestamp - b.timestamp)

    return { ...state, items: newItems }
}

export default function statetimelineReducer(
    state: RigState = {
        start: { info: { span: { normalized: '' } } },
        items: [],
        span: { begin: 0, end: 0 }
    },
    event: Event
): State {
    console.log(event, state)
    if (!event) {
        return state
    }
    if ((event.baseline && event.type != 'event') || event.layer > 0) {
        return state
    }

    switch (event.type) {
        case 'start':
            return {
                ...state,
                start: event.events,
                items: []
            } as RigState
        case 'span':
            state.span = event.events
            // TODO: remove items (+1) events.
            return state
        case 'event':
            if (event.events.length == 0) {
                return state
            }
            state.items = state.items.concat(event.events)
            sort(state.items, (a: DataEvent, b: DataEvent) => a.timestamp - b.timestamp)

            return state
        default:
            return state
    }
}
